import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Badge } from "../components/ui/badge";
import { UsersThree } from "@phosphor-icons/react";

export default function MyTeam() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/employees/my-team").then(({ data }) => setRows(data)).catch(() => setRows([])); }, []);
  return (
    <div className="space-y-6" data-testid="my-team-page">
      <div>
        <div className="text-xs uppercase tracking-[0.25em] text-emerald-700">Workforce</div>
        <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight">My team</h1>
        <p className="text-sm text-zinc-500 mt-2">Everyone mapped under you — solid or dotted line. HR maps people to you from Employees → Edit → Hierarchy.</p>
      </div>
      <div className="border border-zinc-200 bg-white rounded-sm overflow-x-auto">
        <table className="hr-table">
          <thead><tr><th>Employee</th><th>Designation</th><th>Department</th><th>Location</th><th>Reporting</th><th>Status</th></tr></thead>
          <tbody>
            {rows === null && <tr><td colSpan={6} className="text-center py-8 text-sm text-zinc-500">Loading…</td></tr>}
            {rows?.length === 0 && <tr><td colSpan={6} className="text-center py-10 text-sm text-zinc-500" data-testid="my-team-empty"><UsersThree size={24} className="mx-auto mb-2 text-zinc-300" />No one is mapped under you yet.</td></tr>}
            {rows?.map((r) => (
              <tr key={r.id} data-testid={`team-row-${r.id}`}>
                <td><Link to={`/app/employees/${r.id}`} className="text-sm font-medium hover:underline">{r.first_name} {r.last_name}</Link><div className="text-xs font-mono-plex text-zinc-500">{r.employee_code}</div></td>
                <td className="text-sm">{r.designation || "—"}</td>
                <td className="text-sm">{r.department || "—"}</td>
                <td className="text-sm">{r.location || "—"}</td>
                <td><Badge variant="outline" className={`rounded-sm ${r.relation === "solid" ? "bg-emerald-50 text-emerald-800 border-emerald-200" : "bg-blue-50 text-blue-800 border-blue-200"}`}>{r.relation === "solid" ? "Direct report" : "Dotted line"}</Badge></td>
                <td><Badge variant="outline" className="rounded-sm">{r.status}</Badge></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
